import React, { Component } from 'react';
import { BrowserRouter as Router, Route, withRouter, Switch, Redirect } from 'react-router-dom';
import DriverNavigation from 'src/component/Navigation/DriverNavigation';
import Top from 'src/component/Top/Top';
import TripReport from 'src/component/TripReport/TripReport';
import TripReportDetail from 'src/component/TripReportDetail/TripReportDetail';
import MonthlyReport from 'src/component/MonthlyReport/MonthlyReport';
import SafetyMap from 'src/component/SafetyMap/SafetyMap';
import Ranking from 'src/component/Ranking/Ranking';
import Cognito from "src/js/Cognito.js";

class DriverRouter extends Component {

  constructor(props) {
    super(props);

    this.signOut = this.signOut.bind(this);
  }

  signOut() {
    Cognito.signOut();
    window.location.href = '/login';
  }

  render() {
    return (
      <Router>
        <div className='mainContents'>
          <div className="mini-div" />
          <DriverNavigation signOut={this.signOut} />
          <Switch>
            <Route exact path="/top" component={Top} />
            <Route exact path="/trip_report" component={TripReport} />
            <Route exact path="/trip_report/detail" component={TripReportDetail} />
            <Route exact path="/monthly_report" component={MonthlyReport} />
            <Route exact path="/safety_map" component={SafetyMap} />
            <Route exact path="/ranking" component={Ranking} />
            <Route path="*">
              <Redirect to="/top" />
            </Route>
          </Switch>
        </div>
      </Router>
    );
  }
}

export default withRouter(DriverRouter);



// WEBPACK FOOTER //
// ./src/component/Router/DriverRouter.js